import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
  CircularProgress,
  Chip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const ImagePreviewDialog = ({ open, onClose, image }) => {
  const [imageLoading, setImageLoading] = useState(true);

  if (!image) return null;

  const handleOpenInNewTab = () => {
    window.open(image.image_url, '_blank');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          color: 'white'
        }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 1,
          display: 'flex',
          gap: 1
        }}
      >
        <IconButton
          onClick={handleOpenInNewTab}
          sx={{ color: 'white' }}
          title="Open in new tab"
        >
          <OpenInNewIcon />
        </IconButton>
        <IconButton
          onClick={onClose}
          sx={{ color: 'white' }}
          title="Close"
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ p: 0, position: 'relative' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: '60vh'
          }}
        >
          {/* Image Details */}
          <Box
            sx={{
              p: 2,
              display: 'flex',
              gap: 2,
              alignItems: 'center',
              width: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.7)'
            }}
          >
            <Typography variant="h6">
              SKU: {image.sku}
            </Typography>
            <Chip
              label={`Order: ${image.sort_order}`}
              size="small"
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                color: 'white'
              }}
            />
          </Box>

          {/* Image */}
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              p: 2,
              position: 'relative'
            }}
          >
            {imageLoading && (
              <CircularProgress sx={{ color: 'white' }} />
            )}
            <img
              src={image.image_url}
              alt={`Product ${image.sku}`}
              style={{
                maxWidth: '100%',
                maxHeight: '70vh',
                objectFit: 'contain',
                display: imageLoading ? 'none' : 'block'
              }}
              onLoad={() => setImageLoading(false)}
              onError={() => setImageLoading(false)}
            />
          </Box>

          {/* URL Info */}
          <Box
            sx={{
              p: 2,
              width: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              textAlign: 'center'
            }}
          >
            <Typography variant="caption" sx={{ wordBreak: 'break-all' }}>
              {image.image_url}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog;